/* Libs */
import Segment from '../index';
import {Plan} from 'types/cart.types';
import {PartnerAPI} from '@integrations/partners/partners.types';
/**
 * -------------------------------------------------------------------------------------
 * Define the "event name" here, in TRACKING_TYPES
 */
export const TRACKING_TYPES = {
  added: 'Upsell Added',
  viewed: 'Upsell Viewed',
  removed: 'Upsell Removed',
};

/**
 * -------------------------------------------------------------------------------------
 * These are just "actions" that are consolidated in one place that
 * will return your properties structure. Just "method" out what you
 * need to handle.
 */
export type PlanSegment = {
  referrer?: string;
  plan: Partial<Plan> & {planId: number};
  partner: PartnerAPI;
};

export const SEGMENT_UPSELL_SOURCE = {
  SkuUpsell: 'SKU_UPSELL',
  OrderReviewUpsell: 'ORDER_REVIEW_UPSELL',
  CartUpsell: 'CART_UPSELL',
  OrderConfirmationUpsell: 'ORDER_CONFIRMATION_UPSELL',
  ProductUpsell: 'PRODUCT_UPSELL',
  /* Base: This is used when we don't assign a source of the plan add */
  clientStandAlone: 'CLIENT_STANDALONE',
  /* Catch all: can't derive */
  NoPageDerived: 'NO_PAGE_DERIVED',
};

// No referrer supplied, lets try to derive it.
export const derivedPlanUpsellReferrer = () => {
  /* lets align the upsell location with the referrer. */
  const upsellLocationMap: [RegExp, string][] = [
    [/\/(tech-support|landings)\/*/, SEGMENT_UPSELL_SOURCE.SkuUpsell],
    [/\cart\/booking/, SEGMENT_UPSELL_SOURCE.OrderReviewUpsell],
    [/\/cart/, SEGMENT_UPSELL_SOURCE.CartUpsell],
    [/\/orders\/confirmation/, SEGMENT_UPSELL_SOURCE.OrderConfirmationUpsell],
    [/\/product/, SEGMENT_UPSELL_SOURCE.ProductUpsell],
    [/\/plans/, SEGMENT_UPSELL_SOURCE.clientStandAlone],
    [/\.*/, SEGMENT_UPSELL_SOURCE.NoPageDerived],
  ];

  const [, source] = upsellLocationMap.find(([key]) => key.test(window.location.pathname))!;

  return source;
};

export const SegmentTrackingAction = {
  /* When is the upsell viewed */
  upsell({referrer = '', plan, partner = null}: PlanSegment, type: string) {
    // we'll accept the data payload and consolidate the properties here
    const {amount, name, id, planId} = plan;
    const payload = {
      upsell_name: referrer || derivedPlanUpsellReferrer(),
      plan: {
        plan_id: id || planId,
        amount,
        name,
        partner,
      },
    };

    Segment.track(type, payload);
  },
};
